// extracted by mini-css-extract-plugin
module.exports = {"rcSize":"styles_rcSize__2Bo9b"};